import React, {Component} from 'react'
import ItemSideDefault from './ItemSideDefault'

class ItemSide extends Component {
    _renderLayout = () => {
        return <ItemSideDefault {...this.props}/>
    }

    render() {
        const content = this._renderLayout()

        return (
            <div className='ItemSide'>
                {content}
            </div>
        )
    }
}

export default ItemSide
